import { atom } from 'recoil';
import { gameTypesAvailable } from './util.ts'

// Component order same as in FilterBar.js

// gamesChecked is set to 1, because id 1 is the id of Zero-K. Not ideal
// but should work for the forseable future.

export function getFilterBarInternalValuesDefaults() {
  return {
    'startDate': new Date((new Date().setHours(0,0,0,0) - 3*30*24*3600*1000)),
    'endDate': new Date(new Date().setHours(0,0,0,0)),
    'timeGranularity': 7,
    'accountAgeRangeDays': [0, (new Date().getFullYear()-2010)*365],
    'gamesChecked': [1] ,
    'gameTypesChecked': new Array(gameTypesAvailable.length).fill(true),
    'mapTypeAvailableChecked': [false, false],
    'mapSize': [16, 2000],
    'playerId': '',
  }
};

export const filterBarInternalValuesDefaultAtom = atom({
  key: 'filterBarInternalValuesDefault',
  default: getFilterBarInternalValuesDefaults(),
});


export const filterBarInternalValuesAtom = atom({
  key: 'filterBarInternalValues',
  default: [],
});

export const loadDateAtom = atom({
  key: 'loadDate',
  default: {
    "loadDateStart":new Date(new Date().valueOf() - 3*30*24*3600*1000).valueOf(), 
    "loadDateEnd":new Date().valueOf()
  },
});

export const addressFilterAtom = atom({
  key: 'addressFilter',
  default: "addressFilter",
});
